module.exports = __webpack_public_path__ + "img/error_default.1fab3e6d.png";